import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { handleError, handleSuccess } from '../utils';
import './Login.css';

function Login() {
    const navigate = useNavigate();
    const location = useLocation();

    // ✅ IRIS SAML Token Catcher
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const urlToken = queryParams.get('token');

        if (urlToken) {
            // Save token
            localStorage.setItem('token', urlToken);
            
            // Decode token to check profile completion
            try {
                const decoded = JSON.parse(atob(urlToken.split('.')[1]));
                console.log('✅ Token decoded:', decoded);
                
                // Save user info
                localStorage.setItem('loggedInUser', decoded.name || decoded.name || 'NITK Student');
                localStorage.setItem('email', decoded.email);

                // ✅ Route based on profile completion
                if (decoded.isProfileComplete) {
                    handleSuccess('Login successful!');
                    setTimeout(() => navigate('/home', { replace: true }), 500);
                } else {
                    handleSuccess('Please complete your profile');
                    setTimeout(() => navigate('/complete-profile', { replace: true }), 500);
                }
            } catch (err) {
                console.error('Error decoding token:', err);
                handleError('Token decode error');
            }
        }
    }, [location, navigate]);

    const handleIrisLogin = () => {
        window.location.href = 'https://sharemyride.nitk.ac.in/auth/login/iris';
    };

    const features = [
        {
            icon: '👥',
            title: 'Community Driven',
            description: 'Connect with real NITK community members'
        },
        {
            icon: '🎯',
            title: 'Smart Matching',
            description: 'Matches based on destination & time'
        },
        {
            icon: '⚡',
            title: 'Privacy Focused',
            description: 'Sharing phone number feels unsafe? We’ve got you covered'
        },
        {
            icon: '🔒',
            title: 'Safe & Secure',
            description: 'Female only ride options for female users'
        }
    ];

    return (
        <div className="login-container">
            {/* Left Login Card */}
            <div className="login-left">
                <div className="login-card">
                    <div className="login-header">
                        <h1 className="app-title">Share My Ride</h1>
                        <p className="app-subtitle">Share rides, save money, reduce carbon footprint</p>
                    </div>

                    <div className="login-form">
                        <h2 className="form-heading">Sign in to your account</h2>
                        
                        {/* ✅ IRIS LOGIN BUTTON ONLY */}
                        <button 
                            type='button' 
                            onClick={handleIrisLogin}
                            className="iris-login-btn"
                        >
                            🔐 Login with IRIS
                        </button>

                        <p className="login-info">
                            Use your NITK credentials to sign in
                        </p>

                        <div className="login-divider">
                            <span>Trusted by NITK community</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Right Hero Section */}
            <div className="login-right">
                <div className="hero-content">
                    <h2 className="hero-title">Share rides, save money, reduce carbon footprint</h2>
                    <p className="hero-description">
                        Join thousands of NITK students and staff who are already saving money and helping the environment by carpooling together.
                    </p>

                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card">
                                <div className="feature-icon">{feature.icon}</div>
                                <h3 className="feature-title">{feature.title}</h3>
                                <p className="feature-description">{feature.description}</p>
                            </div>
                        ))}
                    </div>

                    <div className="hero-stats">
                        <div className="stat">
                            <div className="stat-number">100+</div>
                            <div className="stat-label">Active Users</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">30+</div>
                            <div className="stat-label">Rides Shared</div>
                        </div>
                        <div className="stat">
                            <div className="stat-number">₹5K+</div>
                            <div className="stat-label">Saved Together</div>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer />
        </div>
    );
}

export default Login;